<template>
  <button 
    class="btn-cta" 
    :class="{ 'btn-cta--large': large }"
    @click="handleClick"
  >
    <slot>Découvrir</slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonCTA',
  props: {
    large: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: ''
    }
  },
    methods: {
    handleClick() {
      if (this.to) {
        // Vérifiez si c'est une URL externe
        if (this.to.startsWith('http://') || this.to.startsWith('https://')) {
          // Ouvrir un lien externe
          window.open(this.to, '_blank');
        } else {
          // Navigation interne avec Vue Router
          this.$router.push(this.to);
        }
      }
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.btn-cta {
  background: $accent-gradient;
  color: $white;
  font-weight: bold;
  font-size: 16px;
  padding: 12px 32px;
  border-radius: $border-radius-pill;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(105, 48, 195, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &--large {
    padding: 16px 40px;
    font-size: 18px;
  }
}
</style>